module.exports = __webpack_public_path__ + "static/media/2.293968c8.svg";